import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { useAtom } from "jotai";
import { omniAtom } from "src/utils/atoms";

const prefix = "playground";

const pogAtom = omniAtom({
  prefix,
  key: "pog",
  value: null as Pog | null,
});

export const usePlayground = () => {
  const [pog, setPog] = useAtom(pogAtom);

  return {
    pogAtom,
    pog,
    setPog,
  };
};
